import React, { useMemo } from "react"
import { registerLocale } from "react-datepicker"
import { useRunRj } from "react-rocketjump"
import { useQsDataTable as useDataTable } from "react-use-datatable/react"
import useQueryParams from "magik-react-hooks/useRouterQueryParams"
import TableAttivita from "../../components/Planner/TableAttivita"
import { AttivitaAdminState } from "./localstate/attivita"
import moment from "moment"
import it from "date-fns/locale/it"
import { LavorazioniState } from "./localstate/lavorazioni"
import Paginator from "../../components/Paginator"
import Spinner from "reactstrap/lib/Spinner"
import { OperatoriState } from "./localstate/operatori"
import DateRangeQsFilter from "../../components/Planner/DateRangeQsFilter"

registerLocale("it", it)
const FORMAT = "YYYY-MM-DD"

const BIG_PAGE_PARAMS = { page_size: 1000 }

const COLOR_ACTIVITIES_LOCKED = "rgba(0, 0, 255, 0.3)"

export default function AttivitaOperatoreAdmin() {
  const [queryParams] = useQueryParams()
  const [{ lavorazioni }] = useRunRj(LavorazioniState, [BIG_PAGE_PARAMS])
  const [{ operatori }] = useRunRj(OperatoriState, [BIG_PAGE_PARAMS])
  const currentData = useMemo(() => {
    if (queryParams.data) {
      return new Date(queryParams.data)
    }
    return new Date()
  }, [queryParams])

  const [
    // Data State
    { attivita, pagination, loading },
    // Table state
    { page, ...filters },
    {
      // DT Actions
      onFiltersChange,
      onFilterChange,
      goToPage,
    },
  ] = useDataTable(AttivitaAdminState, () => ({
    operatore: "",
    lavorazione: "",
    from_data: moment(currentData).startOf('month').format(FORMAT),
    to_data: moment(currentData).endOf('month').format(FORMAT),
  }))

  console.log(lavorazioni, "lavorazioni")

  return (
    <div className="container-fluid">
      {attivita === null && loading && (
        <div className="text-center mt-4">
          <Spinner color="primary" />
        </div>
      )}
      {attivita && (
        <>
          <div className="text-center d-flex justify-content-center text-primary mt-2">
            {filters.from_data || filters.to_date ? (
              <>
                {filters.from_data && (
                  <h4>Da: {moment(filters.from_data).format("DD-MM-YYYY")}</h4>
                )}
                {filters.to_data && (
                  <h4 className="ml-4">
                    A: {moment(filters.to_data).format("DD-MM-YYYY")}
                  </h4>
                )}
              </>
            ) : (
              <h4>Attività operatori</h4>
            )}
          </div>
          <div className="d-flex align-items-center">
            <div
              style={{
                height: 20,
                width: 30,
                background: COLOR_ACTIVITIES_LOCKED,
              }}
            ></div>
            <div className="ml-2">Attività non completate</div>
          </div>
          <div className="filters mt-2">
            <div className="row">
              <div className="col-md-3">
                <select
                  className="form-control"
                  name="operatore"
                  value={filters.operatore}
                  onChange={onFilterChange}
                >
                  <option value="">Filtra per operatore</option>
                  {operatori &&
                    operatori.map((operatore) => (
                      <option value={operatore.id} key={operatore.id}>
                        {operatore.user.first_name} {operatore.user.last_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                <select
                  className="form-control"
                  name="lavorazione"
                  value={filters.lavorazione}
                  onChange={onFilterChange}
                >
                  <option value="">Filtra per lavorazione</option>
                  {lavorazioni &&
                    lavorazioni.map((lavorazione) => (
                      <option value={lavorazione.id} key={lavorazione.id}>
                        {lavorazione.nome}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                <DateRangeQsFilter
                  filters={filters}
                  onFiltersChange={onFiltersChange}
                  startField="from_data"
                  endField="to_data"
                  withPortal={true}
                  customArrowIcon={<div />}
                  small={false}
                  noBorder
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <TableAttivita attivita={attivita} loading={loading} isAdmin />
              <Paginator
                numPages={pagination.numPages}
                currentPage={page}
                goToPage={goToPage}
              />
            </div>
          </div>
        </>
      )}
    </div>
  )
}
